import dayjs, { Dayjs } from 'utilities/dayjs';
import { MessageState } from 'features/chat/chatSlice';

export interface ChatMessageModel extends MessageState {
  parsedCreatedAt: Dayjs;
  isRecent(): boolean;
}

export const ChatMessageModel = (message: MessageState): ChatMessageModel => {
  return {
    parsedCreatedAt: dayjs(message.created_at),
    ...message,

    isRecent() {
      const cutoff = dayjs().subtract(24, 'hour');

      return this.parsedCreatedAt.isAfter(cutoff);
    }
  };
};
